<template>
  <div style="padding: 1vw">
    <div class="container-wrapper">
      <div class="page-title-container">
        <div class="page-title">
          <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
            발행 내역 조회
          </h3>
          <span class="pageDesc">
            병원에서 발급한 인증서·멤버십을 조회할 수 있습니다.
          </span>
        </div>
        <div style="display: flex; align-items: center;">
        </div>
      </div>
    </div>
    <div class="container-wrapper">
      <div class="search-filter-container table-info-filter">
        <div class="search-filter-row">
          <div class="search-filter-title">
            검색어
          </div>
          <div class="search-filter-content">
            <select class="search-select" v-model="searchFilter.filter">
              <option value="">전체</option>
              <option value="customerName">환자명</option>
              <option value="customerMobile">전화번호</option>
              <option value="hospitalName">병원명</option>
              <option value="cNo">사업자번호</option>
            </select>
            <div class="search-input-container">
              <div class="search-icon">
                <i
                  class="fa-regular fa-magnifying-glass"
                />
              </div>
              <input 
                type="text"
                class="search-input-text"
                v-model="searchFilter.keyword"
                @keyup.enter="search"
                placeholder="검색어를 입력하세요"
              />
            </div>
            <button
              class="search-btn"
              @click="search"
            >
              검색
            </button>
            <button
              class="init-btn"
              @click="initFilter"
            >
              초기화
            </button>
          </div>
        </div>
        <div class="search-filter-row">
          <div class="search-filter-title">
            조회 기간
          </div>
          <div class="search-filter-content">
            <div class="date-filter-container">
              <div
                class="date-filter-item"
                :class="searchFilter.selectedDateFilter === 'all' ? 'selected' : ''"
                @click="handleDateFilter('all')"
              >
                전체
              </div>
              <div 
                v-for="item in searchFilter.dateFilters" 
                :key="item"
                class="date-filter-item"
                :class="searchFilter.selectedDateFilter === item ? 'selected' : ''"  
                @click="handleDateFilter(item)"
              >
                {{ item === 'etc' ? '기간 설정' : `최근 ${convertMonthAndYearText(item)}` }}
              </div>
            </div>
            <div class="date-selector-container custom" v-if="searchFilter.selectedDateFilter === 'etc'">
              <n-date-picker 
                v-model:value="searchFilter.startAt" 
                type="date" 
                placeholder="시작 날짜를 선택해 주세요."
                :on-update:value="handleStartAt"
              />
              <div>~</div>
              <n-date-picker 
                v-model:value="searchFilter.endAt" 
                type="date" 
                placeholder="종료 날짜를 선택해 주세요."
                :on-update:value="handleEndAt"
              />
              <div class="filter-desc">(발행 시각 기준)</div>
            </div>
          </div>
        </div>
        <div class="search-filter-row">
          <div class="search-filter-title">
            인증서 상태
          </div>
          <div class="search-filter-content">
            <select 
              class="warranty-status-select"
              v-model="searchFilter.warrantyStatus"
              @change="search"
            >
              <option value="">전체</option>
              <option 
                v-for="item in WarrantyStatusEnum"
                :key="item"
                :value="item"
              >
                {{ convertWarrantyStatusMessage(item) }}
              </option>
            </select>
          </div>
        </div>
        <div class="search-filter-row">
          <div class="search-filter-title">
            진료 과목
          </div>
          <div class="search-filter-content">
            <select 
              class="warranty-status-select"
              v-model="searchFilter.selectedDept"
              @change="search"
            >
              <option value="">전체</option>
              <option v-for="item in deptList" :value="item.code" :key="item">{{ `${item.name}` }}</option>
            </select>
          </div>
        </div>
        <div class="search-filter-row">
          <div class="search-filter-title">
            제조사
          </div>
          <div class="search-filter-content">
            <select 
              class="warranty-status-select"
              v-model="searchFilter.selectedMenu"
              @change="search"
            >
              <option value="">전체</option>
              <option v-for="item in manufacturerList" :value="item._id" :key="item">{{ `${item.name}(${item.cNo})` }}</option>
            </select>
          </div>
        </div>
        <div class="search-filter-row">
          <div class="search-filter-title">
            인증서 타입
          </div>
          <div class="search-filter-content">
            <a-select
              v-model:value="searchFilter.certificateType"
              style="width: 120px"
              placeholder="타입"
              @change="search"
            >
              <a-select-option value="">전체</a-select-option>
              <a-select-option value="online">온라인</a-select-option>
              <a-select-option value="offline">오프라인</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="search-filter-row">
          <div class="search-filter-title">
            테스트 병원 여부
          </div>
          <div class="search-filter-content">
            <a-checkbox v-model:checked="searchFilter.excludeTestCompany" @change="search">
              테스트 병원 제외
            </a-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="container-wrapper">
      <div class="col-xs-12 table-info-filter">
        <div class="total-div">
          <p>
            전체 <span>{{ formatCommaNumber(listSize) }}</span>건
          </p>
        </div>
        <div class="search-container">
          <a-button
            @click="routeToClaraManage"
            type="primary"
          >
              투명교정 발송 조회
          </a-button>
          <a-button
            v-if="activeTab === 'KAKAO' && !isCheckboxVisible"
            @click="batchResendNft"
            type="primary"
            :disabled="selectedResendCount === 0 || isBatchResending"
            class="yellow-button"
          >
            <i class="fa-solid fa-paper-plane"/>
            선택 재발송 ({{ selectedResendCount }}건)
          </a-button>
          <a-button
            @click="downloadExcelList"
            type="primary"
          >
            <i class="fa-solid fa-down-to-bracket"/>
            엑셀 다운로드
          </a-button>
          <a-button
            @click="deleteCompleted"
            type="primary"
            v-if="visibleDeleteCompleteBtn"
          >
            <i class="fa-solid fa-trash"/>
            삭제완료
          </a-button>
          <a-button
              @click="toggleCheckboxColumn"
              type="primary"
              v-if="visibleDeleteBtn"
          >
            <i class="fa-solid fa-trash"/>
            인증서 완전삭제
          </a-button>
          <select class="search-select" v-model="rowsPerPage" @change="search">
            <option :value="10">10개씩 보기</option>
            <option :value="20">20개씩 보기</option>
            <option :value="50">50개씩 보기</option>
          </select>
        </div>
      </div>
    </div>
    <div class="container-wrapper">
      <a-tabs v-model:activeKey="activeTab"
                  @change="handleTabChange"
                  class="custom-tabs">
        <a-tab-pane key="KAKAO" :tab="'카카오톡'">
          <a-table 
            v-if="responseData.length > 0"
            class="ant-table-striped"
            size="small"
            :columns="columns"
            :data-source="responseData"
            :pagination="false"
          
          >
            <template #emptyText>
              <div class="noResult">검색 결과가 없습니다.</div>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="WECHAT" :tab="'위챗'">
          <a-table 
            v-if="responseData.length > 0"
            class="ant-table-striped"
            size="small"
            :columns="columns"
            :data-source="responseData"
            :pagination="false"
          >
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
  <pagination 
    :page-info="paginationData"
    page-name="CertificateList"
    @change-page="paginationHandler"
  />

  <!-- 인증서 발송 추적 기록 모달 -->
  <a-modal
    v-model:visible="modalVisible"
    :footer="null"
    :closable="true"
    :maskClosable="true"
    width="80%"
    class="certificate-trace-modal"
    :destroyOnClose="true"
  >
    <div v-if="traceData" style="max-height: 90vh; overflow-y: auto; padding: 15px;">
      <div style="background-color: #f8f9fa; border-radius: 8px; padding: 15px; margin-bottom: 20px; border-left: 4px solid #1890ff;">
        <h3 style="font-size: 18px; margin-top: 0; margin-bottom: 15px; color: #1890ff;">인증서 기본 정보</h3>
        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
          <div>
            <p style="margin: 5px 0;"><strong style="display: inline-block; width: 120px; color: #555;">NFT ID:</strong> <span style="color: #333;">{{ traceData.nftId }}</span></p>
            <p style="margin: 5px 0;"><strong style="display: inline-block; width: 120px; color: #555;">발송 상태:</strong> <span style="color: #333;">{{ convertWarrantyStatusMessage(traceData.status) }}</span></p>
            <p style="margin: 5px 0;"><strong style="display: inline-block; width: 120px; color: #555;">템플릿 코드:</strong> <span style="color: #333;">{{ traceData.templateCode || '-' }}</span></p>
          </div>
          <div>
            <p style="margin: 5px 0;"><strong style="display: inline-block; width: 120px; color: #555;">메시지 타입:</strong> <span style="color: #333;">{{ traceData.messageType || '-' }}</span></p>
            <p style="margin: 5px 0;"><strong style="display: inline-block; width: 120px; color: #555;">전화번호:</strong> <span style="color: #333;">{{ traceData.phoneNumber ? phoneNumberFormatter(traceData.phoneNumber) : '-' }}</span></p>
          </div>
        </div>
      </div>
      
      <div style="background-color: #f8f9fa; border-radius: 8px; padding: 15px; margin-bottom: 20px; border-left: 4px solid #1890ff;">
        <h3 style="font-size: 18px; margin-top: 0; margin-bottom: 15px; color: #1890ff;">발송 단계 기록</h3>
        <table style="width: 100%; border-collapse: separate; border-spacing: 0; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 5px rgba(0,0,0,0.05);">
          <thead>
            <tr style="background-color: #1890ff;">
              <th style="padding: 12px 8px; text-align: center; color: white; font-weight: 500; border-bottom: 1px solid #e8e8e8;">시간</th>
              <th style="padding: 12px 8px; text-align: center; color: white; font-weight: 500; border-bottom: 1px solid #e8e8e8;">단계</th>
              <th style="padding: 12px 8px; text-align: center; color: white; font-weight: 500; border-bottom: 1px solid #e8e8e8;">메시지</th>
              <th style="padding: 12px 8px; text-align: center; color: white; font-weight: 500; border-bottom: 1px solid #e8e8e8;">결과</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log, index) in formattedLogs" :key="index" :style="{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }">
              <td style="padding: 12px 8px; text-align: center; border-bottom: 1px solid #e8e8e8;">{{ log.timestamp }}</td>
              <td style="padding: 12px 8px; text-align: center; border-bottom: 1px solid #e8e8e8; font-weight: 500;">{{ log.stage }}</td>
              <td style="padding: 12px 8px; text-align: left; border-bottom: 1px solid #e8e8e8;">{{ log.message }}</td>
              <td style="padding: 12px 8px; text-align: center; border-bottom: 1px solid #e8e8e8;">
                <span :style="{
                  display: 'inline-block',
                  padding: '4px 10px',
                  borderRadius: '12px',
                  backgroundColor: log.success === '성공' ? '#e6f7e6' : '#ffebeb',
                  color: log.success === '성공' ? '#52c41a' : '#f5222d',
                  fontWeight: '500'
                }">{{ log.success }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div v-if="traceData.errorMessage" style="background-color: #fff1f0; border-radius: 8px; padding: 15px; margin-bottom: 20px; border-left: 4px solid #f5222d;">
        <h3 style="font-size: 18px; margin-top: 0; margin-bottom: 15px; color: #f5222d;">오류 메시지</h3>
        <div style="color: #f5222d; padding: 10px; background-color: #fff; border-radius: 5px; border: 1px solid #ffccc7; margin-bottom: 10px;">{{ traceData.errorMessage }}</div>
        <div style="text-align: right;">
          <a 
            href="https://docs.nhncloud.com/ko/Notification/KakaoTalk%20Bizmessage/ko/error-code/" 
            target="_blank" 
            rel="noopener noreferrer"
            style="display: inline-flex; align-items: center; color: #1890ff; font-size: 14px; text-decoration: none;"
          >
            <i class="fa-solid fa-circle-info" style="margin-right: 5px;"></i>
            에러내용 상세보기
            <i class="fa-solid fa-external-link" style="margin-left: 5px; font-size: 12px;"></i>
          </a>
        </div>
      </div>
    </div>
  </a-modal>

  <!-- 엑셀 전체 다운로드 월 선택 모달 -->
  <a-modal
    :visible="excelMonthModalVisible"
    :footer="null"
    :destroyOnClose="true"
    :width="420"
    wrap-class-name="excel-download-modal"
    @cancel="excelMonthModalVisible = false"
  >
    <template #title>
      <div class="modal-title">엑셀 다운로드</div>
    </template>

    <div class="modal-content">
      <p class="excel-download-modal__reason">
        조회 결과가 <strong>{{ formatCommaNumber(excelTotalCount) }}건</strong>이라
        한 번에 받을 수 있는 50,000건을 넘습니다. 월을 선택해 나눠 받아 주세요.
      </p>
      <label class="excel-download-modal__label">다운로드할 월</label>
      <a-date-picker
        v-model:value="excelMonth"
        picker="month"
        value-format="YYYYMM"
        format="YYYY년 M월"
        placeholder="월 선택"
        :locale="datePickerLocale"
        :allow-clear="false"
        :input-read-only="true"
        :disabled-date="disabledFutureMonth"
        class="excel-download-modal__picker"
      />

      <ul class="excel-download-modal__notice">
        <li>지금 화면의 검색 조건이 그대로 적용됩니다.</li>
        <li>조회 기간만 선택한 달로 바뀝니다.</li>
        <li>한 번에 최대 50,000건까지 받을 수 있습니다.</li>
      </ul>

      <div class="modal-footer">
        <a-button @click="excelMonthModalVisible = false">취소</a-button>
        <a-button
          type="primary"
          class="yellow-button"
          :loading="isExcelDownloading"
          @click="downloadMonthlyExcel"
        >
          다운로드
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import balloonImage from '@/assets/img/kakao_balloon.svg';
import Pagination from '@/views/components/Pagination.vue';
import enums from '@/enums/common.enums'
import datePickerLocale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import 'dayjs/locale/ko';

// 엑셀 한 번에 받을 수 있는 최대 건수 (inapi CERTILIFE_EXCEL_MAX_ROWS 와 같은 값)
const EXCEL_MAX_ROWS = 50000;
const EXCEL_ROW_LIMIT_CODE = 'EXCEL_ROW_LIMIT_EXCEEDED';

import {
  convertDate,
  oneBtnDialog,
  oneBtnHtmlDialog,
  twoBtnDialog,
  convertDateTime,
  phoneNumberFormatter,
  convertMonthAndYearText,
  formatCommaNumber,
  removeHyphen,
} from '@/utils/utils';
import { 
  MedicalDept,
  WarrantyStatusEnum,
  convertWarrantyStatus,
  IssueMethodEnum,
} from "@/enums/common.enums";

export default {
  name: 'CertificateList',
  components: { 
    Pagination,
  },
  computed: {
    computedNoResultMessage() {
      if(this.calledApiTimes <= 1) {
        return '아직 발행된 인증서가 없습니다.';
      } else {
        return '검색 결과가 없습니다.';
      }
    },
    selectedResendCount() {
      return this.responseData.filter(d => d.isResendChecked).length;
    },
    visibleDeleteCompleteBtn() {
      return this.isCheckboxVisible
    },
    visibleDeleteBtn() {
      return !this.isCheckboxVisible
    },
  },
  data() {
    return {
      activeTab: 'KAKAO',
      formatCommaNumber,
      IssueMethodEnum,
      WarrantyStatusEnum,
      manufacturerList:[],
      isInputFocused: false,
      // 타입
      // 목록 받아오는 변수
      responseData: [],
      deptList: [],
      isMobile: false,

      balloonImage: balloonImage,
      convertDateTime,
      convertWarrantyStatus,
      calledApiTimes: 0,

      // 모달 관련 데이터 추가
      modalVisible: false,
      modalContent: null,
      traceData: null,
      formattedLogs: [],

      searchFilter: {
        filter: '',
        keyword: '',
        warrantyStatus: '',
        selectedDept: '',
        selectedMenu: '',
        certificateType: '',
        // startAt: this.getPastDatesInUnixTime(3),
        // endAt: this.getCurrentUnixTime(),
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
        excludeTestCompany: false,
      },

      // 페이지네이션 관련 변수     
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },

      isCheckboxVisible: false,
      isBatchResending: false,

      // 엑셀 전체 다운로드 (월 단위)
      excelMonthModalVisible: false,
      excelMonth: null, // 'YYYYMM'
      excelTotalCount: 0,
      isExcelDownloading: false,
      datePickerLocale,

      columns: [
        {
          key: 'resendSelection',
          title: () => {
            if (this.activeTab !== 'KAKAO' || this.isCheckboxVisible) return '';
            const count = this.responseData.filter(d => d.isResendChecked).length;
            return (
              <div>
                <span style="font-size: 12px;">{count}건 선택</span><br/>
                <a-checkbox
                  onChange={(e) => {
                    const checkValue = e.target.checked;
                    this.responseData.forEach(item => {
                      if (this.isAvailableForResending(item.issueStatus)) {
                        item.isResendChecked = checkValue;
                      }
                    });
                  }}
                />
              </div>
            );
          },
          width: 60,
          customRender: ({record}) => {
            if (this.activeTab !== 'KAKAO' || this.isCheckboxVisible) return null;
            const disabled = !this.isAvailableForResending(record.issueStatus);
            return (
              <a-checkbox
                checked={record.isResendChecked}
                disabled={disabled}
                onChange={(e) => { record.isResendChecked = e.target.checked; }}
              />
            );
          },
          align: 'center',
        },
        {key: 'index', title: '번호', dataIndex: 'index', align: 'center', },
        {key: 'companyName', title: '발행 병원', dataIndex: 'companyName', align: 'center', },
        {key: 'address', title: '지역', dataIndex: 'address', align: 'center', },
        {key: 'customerName', title: '이름', dataIndex: 'customerName', align: 'center', },
        {key: 'mobile', title: '연락처', dataIndex: 'mobile', align: 'center', 
          customRender: ({record}) => {
              return this.phoneNumberFormatter(record.customerMobile)
            }
        },
        {key: 'issueMethod', title: '발행 방법', dataIndex: 'issueMethod', align: 'center',
          customRender: ({record}) => {
            return <div class="status-chip-wrap">
                <div class={['status-chip', this.convertIssueMethodClass(record.issueMethod)]}>
                  { this.convertIssueMethod(record.issueMethod) || '-' }
                  </div>
              </div>
          }
        },
        {
          key: 'certificateType',
          title: '타입',
          dataIndex: 'certificateType',
          align: 'center',
          customRender: ({record}) => {
            return <a-tag color={record.certificateType === 'offline' ? 'blue' : 'default'}>
              { record.certificateType === 'offline' ? '오프라인' : '온라인' }
            </a-tag>
          }
        },

        {key: 'productType', title: '구분', dataIndex: 'productType', align: 'center', },

        {key: 'group', title: '제조사', dataIndex: 'group', align: 'center', },
        {key: 'itemName', title: '제품명', dataIndex: 'itemName', align: 'center', },
        {key: 'surgeryAt', title: '수술/시술일', dataIndex: 'surgeryAt', align: 'center', 
          customRender: ({record}) => {
              return this.convertDate(record.surgeryAt)
            }
        },
        {key: 'issueStatus', title: '인증서 상태', dataIndex: 'issueStatus', align: 'center', 
          customRender: ({record}) => {
              return <div class="status-chip-wrap">
                            <div 
                              class={['status-chip', this.convertWarrantyStatusClass(record.issueStatus)]}
                            >
                              { this.convertWarrantyStatusMessage(record.issueStatus) }
                            </div>
                          </div>
          }
        },
        {key: 'createAt', title: '발행 시각', dataIndex: 'createAt', align: 'center', 
          customRender: ({record}) => {
            return this.convertDateTime(record.createAt)
          }
        },
        {key: 'resendNotification', title: '알림 재발송', dataIndex: 'resendNotification', align: 'center',
          customRender: ({record}) => (
            <div style="display: flex; justify-content: center;">
              {this.isAvailableForResending(record.issueStatus) && (
                <button
                  class="kakao-icon"
                  style="background-color: #ffe414; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; border: none; border-radius: 100%; cursor: pointer;"
                  onClick={(event) => { 
                    event.stopPropagation();
                    this.resendNft(record._id);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18" fill="none">
                    <path d="M9.0025 1.125C4.03112 1.125 0 4.25326 0 8.10611C0 10.5048 1.56043 12.6186 3.93109 13.8779L2.93081 17.5409C2.84079 17.8657 3.21089 18.1255 3.49597 17.9356L7.87219 15.0323C8.24229 15.0672 8.61739 15.0872 8.9975 15.0872C13.9689 15.0872 18 11.959 18 8.10611C18 4.25326 13.9739 1.125 9.0025 1.125Z" fill="#2F3337"/>
                  </svg>
                </button>
              )}
            </div>
          )
        },
        {key: 'action', title: '발송로그', dataIndex: 'action', align: 'center', 
          customRender: ({record}) => {
            return <a-button 
              type="primary" 
              size="small" 
              onClick={() => this.viewCertificateTrace(record._id)}
            >
              발송로그 확인하기
            </a-button>
          }
        },
      ]
    };
  },
  async mounted() {
    await this.getDeptList();
    await this.getManufacturerList();
    this.handleDateFilter(3);
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  methods: {
    convertDate,
    convertMonthAndYearText,
    phoneNumberFormatter,
    routeToClaraManage() {
      this.$router.push({ 
        name: 'claraManage',
        query: { ...this.$route.query }
      });
    },
    handleResizeColumn(w, col) {
      col.width = w;
    },
    async handleTabChange(key) {
      this.activeTab = key;
      this.paginationData.currentPage = 1;
      await this.getCertificateList(key);
    },
    // 과 목록 가져오기
    async getDeptList() {
      try {
        const response = await this.$apiInstance.get(`/items/medical/depts`);
        if(response.status === 200 || response.status === 201) {
          this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
        }
      } catch(error) {
        console.log(error);
      }
    },
    // 제조사 목록 가져오기
    async getManufacturerList() {
      const obj = {};
      obj.page = 1;
      obj.limit = 1000; // 페이지네이션 관련 변수
      obj.type = "MANUFACTURER";

      try {
        const response = await this.$apiInstance.post(`/companies/list/v2`, obj);
        if(response.status === 200 || response.status === 201) {
          this.manufacturerList = response.data.docs
        }
      } catch(error) {
        console.log(error);
      }
    },
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getCertificateList();    
    },
    // 주요 API
    // 전체 목록 가져오기

    async getCertificateList(snsType) {
      this.columns = this.columns.filter(column => column.key !== 'selection');
      this.isCheckboxVisible = false;

      const obj = {};
      obj.page = this.paginationData.currentPage;
      obj.limit = this.rowsPerPage;
      obj.search = this.searchFilter.filter;
      obj.snsType = snsType ? snsType : this.activeTab
      if(this.searchFilter.keyword) obj.condition = removeHyphen(this.searchFilter.keyword);
      if(this.searchFilter.selectedDept) obj.medicalDept = this.searchFilter.selectedDept;
      if(this.searchFilter.selectedMenu) obj.manufacturerId = this.searchFilter.selectedMenu;
      if(this.searchFilter.excludeTestCompany) obj.excludeTestCompany = this.searchFilter.excludeTestCompany;
      if(this.searchFilter.certificateType) obj.certificateType = this.searchFilter.certificateType;
      if(this.searchFilter.startAt && this.searchFilter.startAt) {
        obj.startAt = this.unixTimeToYYYYMMDD(this.searchFilter.startAt);
        obj.endAt = this.unixTimeToYYYYMMDD(this.searchFilter.endAt);
      } else {
        obj.startAt = null
        obj.endAt = null
      }
      obj.issueStatus = this.searchFilter.warrantyStatus;
      try {
        const response = await this.$apiInstance.post(`/nfts/certilife/list`, obj);
        if (response.status === 200 || response.status === 201) {
          this.calledApiTimes ++;
          if(response.data.docs) {
            this.responseData = response.data.docs;
          } else {
            this.responseData = [];
          }
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
            this.responseData[i].isResendChecked = false;
          }

          this.$store.commit('setIsLoading', false);
        }
      } catch (error) {
        console.log(error);
        await oneBtnDialog(`보증서 목록 로드 실패`, 
        `보증서 목록 로드에 실패했습니다.`, 
        false);
      }
    },

    async downloadExcelList() {
      // 선택한 인증서가 있으면 그것만
      const selectedIds = this.responseData
        .filter(d => d.isResendChecked || d.isChecked)
        .map(d => d._id);
      if (selectedIds.length > 0) {
        const isConfirmed = await twoBtnDialog(
          '엑셀 다운로드',
          `선택한 ${selectedIds.length}건만 다운로드합니다. 전체를 받으려면 선택을 해제한 뒤 다시 눌러 주세요.`,
          '다운로드'
        );
        if (!isConfirmed) return;
        await this.requestExcelDownload({ nftIds: selectedIds }, `발행목록_선택${selectedIds.length}건`);
        return;
      }

      // 화면 조회 결과가 상한을 넘을 때만 월 단위로 나눠 받는다
      if (this.listSize > EXCEL_MAX_ROWS) {
        this.openExcelMonthModal(this.listSize);
        return;
      }
      const result = await this.requestExcelDownload(this.buildExcelSearchParams(), '발행목록');
      // 검색 후 필터만 바꾼 경우 등 서버 집계가 상한을 넘으면 월 단위로 전환
      if (result.code === EXCEL_ROW_LIMIT_CODE) {
        this.openExcelMonthModal(result.totalCount);
      }
    },

    openExcelMonthModal(totalCount) {
      // 화면에 조회 기간이 있으면 그 마지막 달, 없으면 이번 달로 시작
      const now = new Date();
      this.excelMonth = this.searchFilter.endAt
        ? this.unixTimeToYYYYMMDD(this.searchFilter.endAt).replace(/\D/g, '').substring(0, 6)
        : `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
      this.excelTotalCount = totalCount || 0;
      this.excelMonthModalVisible = true;
    },

    // 목록 조회(getCertificateList)와 같은 조건. 기간을 넘기면 그 기간으로 대체
    buildExcelSearchParams(startAt, endAt) {
      const obj = {};
      obj.search = this.searchFilter.filter;
      obj.snsType = this.activeTab;
      if(this.searchFilter.keyword) obj.condition = removeHyphen(this.searchFilter.keyword);
      if(this.searchFilter.selectedDept) obj.medicalDept = this.searchFilter.selectedDept;
      if(this.searchFilter.selectedMenu) obj.manufacturerId = this.searchFilter.selectedMenu;
      if(this.searchFilter.warrantyStatus) obj.issueStatus = this.searchFilter.warrantyStatus;
      if(this.searchFilter.excludeTestCompany) obj.excludeTestCompany = this.searchFilter.excludeTestCompany;
      if(this.searchFilter.certificateType) obj.certificateType = this.searchFilter.certificateType;
      if (startAt && endAt) {
        obj.startAt = startAt;
        obj.endAt = endAt;
      } else if (this.searchFilter.startAt && this.searchFilter.endAt) {
        obj.startAt = this.unixTimeToYYYYMMDD(this.searchFilter.startAt);
        obj.endAt = this.unixTimeToYYYYMMDD(this.searchFilter.endAt);
      }
      return obj;
    },

    disabledFutureMonth(current) {
      if (!current) return false;
      const now = new Date();
      const thisMonth = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}`;
      return current.format('YYYYMM') > thisMonth;
    },

    async downloadMonthlyExcel() {
      if (!this.excelMonth) {
        this.$message.warning('다운로드할 월을 선택해 주세요.');
        return;
      }
      const year = Number(this.excelMonth.substring(0, 4));
      const month = Number(this.excelMonth.substring(4, 6));
      const lastDay = new Date(year, month, 0).getDate();

      const obj = this.buildExcelSearchParams(
        `${this.excelMonth}01`,
        `${this.excelMonth}${String(lastDay).padStart(2, '0')}`,
      );
      const result = await this.requestExcelDownload(obj, `발행목록_${this.excelMonth}`);
      if (result.ok) this.excelMonthModalVisible = false;
    },

    async requestExcelDownload(obj, filePrefix) {
      const year = new Date().getFullYear();
      const month = String(new Date().getMonth() + 1).padStart(2, '0');
      const day = String(new Date().getDate()).padStart(2, '0');

      const formattedDate = `${year}${month}${day}`;
      try {
        this.isExcelDownloading = true;
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.post(
            `/nfts/manufacturer/list/excel`,obj,
            {
              headers: {
                'Content-Type': 'application/json',
              },
              responseType: 'blob',
            }
        );

        if (response.status === 200 || response.status === 201) {
          const blob = new Blob([response.data], {
            type: 'application/octet-stream',
          });

          const url = URL.createObjectURL(blob);

          const downloadLink = document.createElement('a');
          downloadLink.href = url;
          downloadLink.download = `${filePrefix}_${formattedDate}.xlsx`;
          downloadLink.click();

          URL.revokeObjectURL(url);
          return { ok: true };
        }
        return { ok: false };
      } catch (error) {
        console.error('Error downloading Excel file:', error);
        const body = await this.readBlobErrorBody(error);
        // 월 선택 창 밖에서 상한을 넘으면 호출한 쪽이 월 단위로 전환한다
        if (body.code === EXCEL_ROW_LIMIT_CODE && !this.excelMonthModalVisible) {
          return { ok: false, code: body.code, totalCount: body.totalCount };
        }
        await oneBtnDialog('엑셀 다운로드 실패', body.message, false);
        return { ok: false, code: body.code };
      } finally {
        this.isExcelDownloading = false;
        this.$store.commit('setIsLoading', false);
      }
    },

    // responseType: 'blob' 이라 서버 오류 응답도 Blob 으로 온다
    async readBlobErrorBody(error) {
      const fallback = '엑셀 파일을 만들지 못했습니다. 잠시 후 다시 시도해 주세요.';
      const data = error?.response?.data;
      if (!(data instanceof Blob)) return { message: fallback };
      try {
        const body = JSON.parse(await data.text());
        const message = Array.isArray(body.message) ? body.message.join('\n') : body.message;
        return { ...body, message: message || fallback };
      } catch (e) {
        return { message: fallback };
      }
    },


    async search() {
      if(!await this.validateSearchFilter()) return;
      this.paginationData.currentPage = 1;
      await this.getCertificateList();
    },
    async searchAllPeriod() {
      this.paginationData.currentPage = 1;
      this.searchFilter.startAt = null;
      this.searchFilter.endAt = this.getCurrentUnixTime();
      await this.getCertificateList();
    },
    async initFilter() {
      this.searchFilter = {
        filter: '',
        keyword: '',
        warrantyStatus: '',
        selectedDept: '',
        selectedMenu: '',
        certificateType: '',
        startAt: null,
        endAt: null,
        selectedDateFilter: 'all',
        dateFilters: [3, 12, 36, 'etc'],
        excludeTestCompany: true,
      }
      this.handleDateFilter(3);
    },
    handleStartAt(value) {
      this.paginationData.currentPage = 1;
      this.searchFilter.startAt = value;
      this.search();
    },
    handleEndAt(value) {
      this.paginationData.currentPage = 1;
      this.searchFilter.endAt = value;
      this.search();
    },
    handleSelectFilter() {
      this.paginationData.currentPage = 1;
      this.search();
    },
    handleDateFilter(value) {
      this.paginationData.currentPage = 1;
      if(value === this.searchFilter.selectedDateFilter) return;
      
      this.searchFilter.selectedDateFilter = value;
      if (value === 'all') {
        this.searchFilter.startAt = null;
        this.searchFilter.endAt = null;
      } else {
        this.searchFilter.startAt = this.getPastDatesInUnixTime(value);
        this.searchFilter.endAt = this.getCurrentUnixTime();
      }
      this.search();
    },
    getCurrentUnixTime() {
        const now = new Date();
        return Math.floor(now.getTime());
    },
    getPastDatesInUnixTime(value) {
      const now = new Date();
      const threeMonthsAgo = new Date(now.setMonth(now.getMonth() - 3));
      const twelveMonthsAgo = new Date(now.setMonth(now.getMonth() - 9)); 
      const thirtySixMonthsAgo = new Date(now.setMonth(now.getMonth() - 24)); 

      now.setMonth(now.getMonth() + 36);

      const nowUnix = Math.floor(now.getTime());
      const threeMonthsAgoUnix = Math.floor(threeMonthsAgo.getTime());
      const twelveMonthsAgoUnix = Math.floor(twelveMonthsAgo.getTime());
      const thirtySixMonthsAgoUnix = Math.floor(thirtySixMonthsAgo.getTime());

      switch(value) {
        case 3:
          return threeMonthsAgoUnix;
        case 12: 
          return twelveMonthsAgoUnix;
        case 36: 
          return thirtySixMonthsAgoUnix;
        default: 
          return nowUnix;
      }
    },
    unixTimeToYYYYMMDD(unixTime) {
        // Create a new Date object from the Unix timestamp
        // Remember to multiply by 1000 because JavaScript expects milliseconds
        const date = new Date(unixTime);

        // Extract the year, month, and day as individual components
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // +1 because getMonth() returns 0-11
        const day = date.getDate().toString().padStart(2, '0');
        // Combine components into YYYYMMDD format
        return `${year}${month}${day}`;
    },
    async validateSearchFilter() {
      // 필터 걸어놓고 검색을 안함
      // 시작날짜가 과거날짜보다 큼
      if(this.searchFilter.startAt && !this.searchFilter.endAt) {
        return false;
      }
      if(this.searchFilter.startAt > this.searchFilter.endAt) {
        await oneBtnDialog('날짜 오류', '검색 시작일은 종료일보다 작아야 합니다.', false);
        return false;
      }
      return true;
    },


    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getCertificateList();
    },
    async enter() {
      if (!this.searchFilter && this.condition) {
        await oneBtnDialog(
            '검색 필터 미선택',
            '검색 필터를 선택해 주세요.',
            false
        );
      } else {
        this.paginationData.currentPage = 1;
        this.getCertificateList();
      }
    },
    // 인증서 상태 코드 텍스트로 변환

    convertIssueMethod(input) {
      switch(input) {
        case 'single':
        return '단건';
        case 'bulk':
        return '대량';
      }
    },
    convertIssueMethodClass(input) {
      switch(input) {
        case 'single':
        return 'single';
        case 'bulk':
        return 'bulk';
      }
    },


    convertWarrantyStatusMessage(input) {
      const { WarrantyStatusEnum } = enums();
      switch(input) {
        case WarrantyStatusEnum.REQUEST_ISSUED:
        return '발행 요청됨';
        case WarrantyStatusEnum.ISSUED:
        return '지갑 저장됨';
        case WarrantyStatusEnum.DISPOSED:
        return '삭제됨';
        case WarrantyStatusEnum.RETURNED:
        return '회수됨';
        case WarrantyStatusEnum.BIZ_SEND_ERROR:
        return '발송 실패';
        case WarrantyStatusEnum.SEND_LMS:
        return '문자 전송됨';
        case WarrantyStatusEnum.SEND_BIZ:
        return '카톡 전송됨';
        case WarrantyStatusEnum.WECHAT_ISSUED:
        return '위챗 전송됨';
        default:
        return '-';
      }
    },
    convertWarrantyStatusClass(input) {
      const { WarrantyStatusEnum } = enums();
      switch(input) {
        case WarrantyStatusEnum.REQUEST_ISSUED:
        return WarrantyStatusEnum.REQUEST_ISSUED;
        case WarrantyStatusEnum.ISSUED:
        return WarrantyStatusEnum.ISSUED;
        case WarrantyStatusEnum.DISPOSED:
        return WarrantyStatusEnum.DISPOSED;
        case WarrantyStatusEnum.RETURNED:
        return WarrantyStatusEnum.RETURNED;
        case WarrantyStatusEnum.BIZ_SEND_ERROR:
        return WarrantyStatusEnum.BIZ_SEND_ERROR;
        case WarrantyStatusEnum.SEND_LMS:
        return WarrantyStatusEnum.SEND_LMS;
        case WarrantyStatusEnum.SEND_BIZ:
        return WarrantyStatusEnum.SEND_BIZ;
        case WarrantyStatusEnum.WECHAT_ISSUED:
        return WarrantyStatusEnum.WECHAT_ISSUED;
        default:
        return '';
      }
    },

    convertIssueType(code) {
      switch (code) {
        case 'Y':
          return '연동 완료';
        case 'N':
          return '미연동';
        default:
          return '-';
      }
    },
    toggleCheckboxColumn() {
      this.isCheckboxVisible = !this.isCheckboxVisible;

      if (this.isCheckboxVisible) {
        // 선택 컬럼 추가
        const selectionColumn = {
          title: () => {
            const deleteCount = this.responseData.filter(item => item.isChecked).length
            return (
                <div>
                  <span>{deleteCount}개 선택됨</span><br/>
                  <a-checkbox style={{cursor: "pointer", }}
                              onChange={(e) => {
                                const checkValue = e.target.checked;
                                this.responseData.forEach(item => {
                                  item.isChecked = checkValue;
                                });
                              }
                              }></a-checkbox>
                </div>
            );
          },
          key: 'selection',
          width: 80,
          customRender: ({record}) => {
            return <a-checkbox checked={record.isChecked}
                                onChange={(e) => record.isChecked = e.target.checked}></a-checkbox>;
          },
          align: 'center'
        };
        this.columns = [selectionColumn, ...this.columns]; // 선택 컬럼을 목록의 맨 앞에 추가
      } else {
        // 선택 컬럼 제거
        this.columns = this.columns.filter(column => column.key !== 'selection');
      }
    },

    // 일괄 삭제 기능
    async deleteCompleted() {
      const selectedIds = this.responseData.filter(d => d.isChecked).map(d => d._id);
      if (selectedIds.length < 1) {
        await oneBtnDialog('알림', `삭제할 인증서를 선택해주세요.`)
        return
      }

      const isConfirmed = await twoBtnDialog(
        '알림',
        `선택한 ${selectedIds.length}개 인증서를 삭제하시겠습니까?`,
        '삭제'
      );
      if (!isConfirmed) return;

      try {
        const bodyParams = {
          ids: selectedIds,
          snsType: this.activeTab,
        };
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.post('/nfts/certilife/delete/batch', bodyParams);
        this.$store.commit('setIsLoading', false);
        if (response.status === 200 || response.status === 201) {
          this.columns = this.columns.filter(column => column.key !== 'selection');
          this.isCheckboxVisible = false; 
          oneBtnDialog('알림', `${selectedIds.length}건의 인증서가 삭제되었습니다.`).then(_ =>{
            this.getCertificateList(); // 목록 새로고침
          })
        }
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('일괄 삭제 실패:', error);
      }
    },
    async viewCertificateTrace(nftId) {
      try {
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.get(`/nfts/certificate-trace/${nftId}`);

        if (response.status === 200 || response.status === 201) {
          this.traceData = response.data;
          
          // 로그 데이터 가공
          this.formattedLogs = this.traceData.logs.map(log => {
            return {
              timestamp: this.convertDateTime(log.timestamp),
              stage: log.stage,
              message: log.message,
              success: log.success ? '성공' : '실패',
              details: log.details
            };
          });
          
          // 모달 표시
          this.modalVisible = true;
        }
      } catch (error) {
        console.error('발송 추적 기록 조회 실패:', error);
        // 404 에러인 경우 경고 메시지만 표시
        if (error.response && error.response.status === 404) {
          this.$message.warn(error.response.data.message || '인증서 발송 추적 기록이 존재하지 않습니다.');
        } else {
          // 다른 에러는 기존처럼 다이얼로그로 표시
          await oneBtnDialog('발송 추적 기록 조회 실패', '데이터를 가져오는 중 오류가 발생했습니다.', false);
        }
      } finally {
        this.$store.commit('setIsLoading', false);
      }
    },
    /**
     * 인증서 상태에 따라 재발송 가능 여부 확인
     */
    isAvailableForResending(status) {
      // 삭제되거나 회수된 인증서는 재발송 불가
      if (status === WarrantyStatusEnum.DISPOSED || status === WarrantyStatusEnum.RETURNED) {
        return false;
      }
      return true;
    },

    /**
     * 카카오톡 인증서 재발송
     */
    async resendNft(nftId) {
      const isConfirmed = await twoBtnDialog(
        '알림톡 다시 보내기', 
        '환자에게 인증서 알림톡을 다시 보내시겠습니까?',
        '재발송'
      );
      
      if (!isConfirmed) return;
      
      try {
        this.$store.commit('setIsLoading', true);
        const response = await this.$apiInstance.post(`/nfts/re-send/${nftId}`);
        this.$store.commit('setIsLoading', false);
        
        if (response.status === 200 || response.status === 201) {
          await oneBtnDialog('알림톡 발송 완료', '환자에게 인증서 알림톡이 다시 발송되었습니다.', false);
          await this.getCertificateList(); // 목록 새로고침
        }
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('알림톡 재발송 실패:', error);
        await oneBtnDialog('알림톡 발송 실패', '인증서 알림톡 재발송에 실패하였습니다.', false);
      }
    },

    /**
     * 카카오톡 인증서 일괄 재발송
     */
    async batchResendNft() {
      const selectedIds = this.responseData
        .filter(d => d.isResendChecked && this.isAvailableForResending(d.issueStatus))
        .map(d => d._id);

      if (selectedIds.length === 0) {
        await oneBtnDialog('알림', '재발송할 인증서를 선택해주세요.');
        return;
      }

      const isConfirmed = await twoBtnDialog(
        '알림톡 일괄 재발송',
        `선택한 ${selectedIds.length}건의 인증서를 재발송하시겠습니까?`,
        '재발송'
      );
      if (!isConfirmed) return;

      try {
        this.isBatchResending = true;
        this.$store.commit('setIsLoading', true);

        const response = await this.$apiInstance.post('/nfts/re-send/batch', {
          nftIds: selectedIds
        });

        this.$store.commit('setIsLoading', false);

        if (response.status === 200 || response.status === 201) {
          const { successCount, failedCount, results } = response.data;
          const failedResults = results.filter(r => r.result === 'failed');

          if (failedResults.length > 0) {
            const failedRows = failedResults
              .map(r => `<tr><td style="padding:6px 8px; border:1px solid #ddd;">${r.customerName}</td><td style="padding:6px 8px; border:1px solid #ddd;">${r.reason || '알 수 없는 오류'}</td></tr>`)
              .join('');
            const html = `
              <p style="margin-bottom:12px;">성공 <strong>${successCount}</strong>건 / 실패 <strong>${failedCount}</strong>건</p>
              <table style="width:100%; border-collapse:collapse;">
                <thead><tr style="background:#f5f5f5;">
                  <th style="padding:8px; border:1px solid #ddd; text-align:left;">환자명</th>
                  <th style="padding:8px; border:1px solid #ddd; text-align:left;">사유</th>
                </tr></thead>
                <tbody>${failedRows}</tbody>
              </table>
            `;
            await oneBtnHtmlDialog('일괄 재발송 결과', html);
          } else {
            await oneBtnDialog('일괄 재발송 완료',
              `${successCount}건의 인증서 알림톡이 재발송되었습니다.`);
          }

          await this.getCertificateList();
        }
      } catch (error) {
        this.$store.commit('setIsLoading', false);
        console.error('알림톡 일괄 재발송 실패:', error);
        await oneBtnDialog('일괄 재발송 실패', '인증서 알림톡 일괄 재발송에 실패하였습니다.', false);
      } finally {
        this.isBatchResending = false;
      }
    },
  },
};
</script>

<!-- 모달 커스텀 스타일 (전역 적용) -->
<style lang="scss">
/* 인증서 발송 추적 기록 모달 스타일 */
.certificate-trace-modal {
  .ant-modal-header {
    padding: 0;
    height: 0;
    border: none;
    display: none;
  }
  
  .ant-modal-body {
    padding: 0;
    max-height: 90vh;
  }
  
  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
    margin: 50px auto;
  }
  
  .ant-modal-close {
    top: 10px;
    right: 10px;
    color: #999;
    
    &:hover {
      color: #1890ff;
    }
  }
}

/* 엑셀 다운로드 월 선택 모달 — 전역 .modal-content 의 테두리·최소 높이는 쓰지 않는다 */
.excel-download-modal {
  .modal-title {
    font-size: 16px;
    font-weight: bold;
  }

  .modal-content {
    border: none;
    border-radius: 0;
    min-height: 0;
    padding: 8px 0 0;
  }

  .excel-download-modal__reason {
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
  }

  .excel-download-modal__label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }

  .excel-download-modal__picker {
    width: 100%;
  }

  .excel-download-modal__notice {
    margin: 16px 0 0;
    padding: 12px 14px 12px 28px;
    background-color: #f7f7f8;
    border-radius: 6px;
    font-size: 13px;
    line-height: 1.7;
    color: #666;

    li {
      list-style: disc;
    }
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 24px;
    padding: 0;
    border-top: none;
  }
}
</style>

<!-- 스타일 섹션 추가 -->
<style lang="scss" scoped>
  @import '@/assets/scss/certificates.scss';
</style>